module.exports = __webpack_public_path__ + "img/help-center-screenshot.e902ce85.png";